import React from "react";
import "./ApplicantSummary.scss";
import { BasicInformationSummary } from "../BasicInformation/BasicInformationSummary";
import { PersonalAccountAcceptableUseSummary } from "../PersonalAccountAcceptableUse/PersonalAccountAcceptableUseSummary";
import { KeyPeopleSummaryV2 } from "../KeyPeople/KeyPeopleSummaryV2";
import { JointAccountOwnersSummaryV2 } from "../JointAccountOwners/JointAccountOwnersSummaryV2";
import { PersonalAccountBeneficiariesSummaryV2 } from "../PersonalAccountBeneficiaries/PersonalAccountBeneficiariesSummaryV2";
import { OptInsSummary } from "../OptIns/OptInsSummary";
import { AccountDetailsSummary } from "../AccountDetails/AccountDetailsSummary";
import { OrganizationInformationSummary } from "../OrganizationInformation/OrganizationInformationSummary";
import { OrganizationAccountAcceptableUseSummary } from "../OrganizationAccountAcceptableUse/OrganizationAccountAcceptableUseSummary";
import { useFinancialApplicationCoreData } from "@/hooks/useFinancialApplicationCoreData";

export interface ApplicantSummaryProps {
  financialApplicationId: string;
}

export const ApplicantSummary: React.FC<ApplicantSummaryProps> = ({ financialApplicationId }) => {
  const { coreData, conditionalFlags } = useFinancialApplicationCoreData(financialApplicationId);

  return (
    <div className="applicant-summary__content">
      {/* Personal Accounts Summary */}
      <BasicInformationSummary financialApplicationId={financialApplicationId} />
      {conditionalFlags.isAccountDetailsEnabled && coreData?.hasPersonalAccountSelected && (
        <AccountDetailsSummary financialApplicationId={financialApplicationId} forPersonalAccounts />
      )}
      {conditionalFlags.isJointAccountOwnersEnabled && (
        <JointAccountOwnersSummaryV2 financialApplicationId={financialApplicationId} />
      )}
      {conditionalFlags.isPersonalAccountBeneficiariesEnabled && (
        <PersonalAccountBeneficiariesSummaryV2 financialApplicationId={financialApplicationId} />
      )}
      {conditionalFlags.isPersonalAccountAcceptableUseEnabled && (
        <PersonalAccountAcceptableUseSummary financialApplicationId={financialApplicationId} />
      )}
      {conditionalFlags.isPersonalAccountAcceptableUseEnabled && (
        <OptInsSummary financialApplicationId={financialApplicationId} forPersonalAccounts />
      )}

      {/* Entity Accounts Summary */}

      {conditionalFlags.isOrganizationInfoEnabled && (
        <OrganizationInformationSummary financialApplicationId={financialApplicationId} />
      )}
      {conditionalFlags.isAccountDetailsEnabled && (coreData?.hasBusinessAccountSelected || coreData?.hasIoltaAccountSelected) && (
        <AccountDetailsSummary financialApplicationId={financialApplicationId} forPersonalAccounts={false} />
      )}
      {conditionalFlags.isKeyPeopleEnabled && (
        <KeyPeopleSummaryV2 financialApplicationId={financialApplicationId} />
      )}
      {conditionalFlags.isOrganizationAcceptableUseEnabled && (
        <OrganizationAccountAcceptableUseSummary financialApplicationId={financialApplicationId} />
      )}
      {conditionalFlags.isOrganizationAcceptableUseEnabled && (
        <OptInsSummary
          financialApplicationId={financialApplicationId}
          forPersonalAccounts={false}
        />
      )}
    </div>
  );
};
